import { render, staticRenderFns } from "./CustomSwitchItem.vue?vue&type=template&id=dac960f6&scoped=true&lang=pug&"
import script from "./CustomSwitchItem.vue?vue&type=script&lang=js&"
export * from "./CustomSwitchItem.vue?vue&type=script&lang=js&"
import style0 from "./CustomSwitchItem.vue?vue&type=style&index=0&id=dac960f6&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dac960f6",
  null
  
)

export default component.exports